import { useState,useEffect } from "react";
import { Button, Nav, Navbar } from "react-bootstrap"




const Header = ({current_page}: {current_page: string}) => {
  
  return (
    
    <Navbar expand="lg" bg="dark" variant='dark' style={{ minWidth: 700 }}>
      
      <Navbar.Brand className="font-weight-bold" href="/LogTrack">Loco Terminal Track</Navbar.Brand>
      <Nav className='mr-auto'>
        {current_page === "Tracker" ? <Nav.Item><Nav.Link href='/LogTrack' className="active">Tracker</Nav.Link></Nav.Item> : <Nav.Item><Nav.Link href='/LogTrack'>Tracker</Nav.Link></Nav.Item>}
        {current_page === "Setting" ? <Nav.Item><Nav.Link href='/Setting' className="active">Setting</Nav.Link></Nav.Item> : <Nav.Item><Nav.Link href='/Setting'>Setting</Nav.Link></Nav.Item>}
      </Nav>
    </Navbar>
  )
}

export default Header